import { Fragment, jsx } from "react/jsx-runtime";
import { AppleIcon } from "../../icons/AppleIcon";
import { GoogleIcon } from "../../icons/GoogleIcon";
import { LINEIcon } from "../../icons/LINEIcon";
const VariantIcon = ({ variant, fallback }) => {
  return variant === "authGoogle" ? /* @__PURE__ */ jsx(GoogleIcon, {}) : variant === "authLINE" ? /* @__PURE__ */ jsx(LINEIcon, {}) : variant === "authApple" ? /* @__PURE__ */ jsx(AppleIcon, {}) : /* @__PURE__ */ jsx(Fragment, { children: fallback });
};
export {
  VariantIcon
};
